<se-fe-page [seFeDataLoaded]="!loading" seFeDataWidth="full">
  <se-fe-header
    seFePageHeader
    [seFeDataTitle]="'LIST_VIEW.title' | translate"
    seFeDataSize="display"
    class="se-fe-page__header">
    <se-fe-button
      data-dd-action-name="Add Sale Item"
      class="item-list__add-button"
      seFeHeaderActions
      [seFeDataEmphasis]="'high'"
      (click)="toggleItemModal()">
      <se-fe-icon seFeIconBefore seFeDataName="plus_circle" seFeDataSize="700" [seFeDataMargin]="false"></se-fe-icon>
      {{ 'LIST_VIEW.add_sale_item' | translate }}
    </se-fe-button>
  </se-fe-header>

  <se-fe-tab-group
    seFePageTabs
    [seFeDataTabPanel]="saleItemsTabPanel"
    [seFeDataAriaLabel]="'LIST_VIEW.tabs_label' | translate">
    <se-fe-tab-item>
      <a href="" [seFeTab]="activeTab === 'active'" (click)="selectTab('active', $event)">
        {{ 'LIST_VIEW.active' | translate }}
      </a>
    </se-fe-tab-item>
    <se-fe-tab-item>
      <a href="" [seFeTab]="activeTab === 'archived'" (click)="selectTab('archived', $event)">
        {{ 'LIST_VIEW.archived' | translate }}
      </a>
    </se-fe-tab-item>
  </se-fe-tab-group>

  <se-fe-tab-panel #saleItemsTabPanel seFePageContent>
    <se-fe-card>
      <se-fe-card-content>
        @if (listIsEmpty()) {
          <se-fe-empty-state [seFeDataTitle]="'LIST_VIEW.no_sale_items' | translate">
            <se-fe-icon seFeEmptyStateIcon seFeDataName="price_tag_thin" seFeDataSize="950"></se-fe-icon>
            <span [translate]="'LIST_VIEW.empty_state_description'"></span>
            <a
              seFeLink
              [translate]="'LIST_VIEW.learn_more'"
              href="https://sportsengine.elevio.help/en/articles/935"
              target="_blank"></a>
            <se-fe-button
              data-dd-action-name="Add Sale Item"
              seFeEmptyStateAction
              seFeDataEmphasis="high"
              (click)="toggleItemModal()">
              {{ 'LIST_VIEW.add_sale_item' | translate }}
            </se-fe-button>
          </se-fe-empty-state>
        } @else {
          <div class="item-list__toolbar">
            <form class="item-list__search" [formGroup]="searchForm" (ngSubmit)="submitSearch()">
              <se-fe-form-field [seFeDataConfig]="searchFieldConfig" class="item-list__search-field">
                <se-fe-form-field-text
                  formControlName="search"
                  [seFeDataPlaceholder]="'LIST_VIEW.search' | translate">
                </se-fe-form-field-text>
              </se-fe-form-field>
              <se-fe-button seFeDataEmphasis="high" seFeDataType="submit">Search</se-fe-button>
            </form>

            @if (activeTab === 'active' && selectedItemIds.size) {
              <se-fe-button
                data-dd-action-name="Bulk Archive Sale Items"
                class="item-list__bulk-archive-button"
                [seFeTestId]="'bulk-archive-sale-items'"
                [seFeDataEmphasis]="'low'"
                [seFeDataIsDisabled]="bulkArchiving"
                [seFeDataIsLoading]="bulkArchiving"
                (click)="confirmBulkArchive($event)">
                <se-fe-icon
                  seFeIconBefore
                  seFeDataName="archive"
                  seFeDataSize="700"
                  [seFeDataMargin]="false"></se-fe-icon>
                {{ 'LIST_VIEW.bulk_archive' | translate }}
              </se-fe-button>
            }
          </div>

          @if (listIsLoading()) {
            <se-fe-spinner class="item-list__loading" [seFeDataSize]="900" [seFeDataCenter]="true"></se-fe-spinner>
          } @else if (archivedListIsEmpty()) {
            <se-fe-empty-state [seFeDataTitle]="'LIST_VIEW.no_archived_sale_items' | translate">
              <se-fe-icon seFeEmptyStateIcon seFeDataName="price_tag_thin" seFeDataSize="950"></se-fe-icon>
              {{ 'LIST_VIEW.archived_empty_state_description' | translate }}
            </se-fe-empty-state>
          } @else if (searchedListIsEmpty()) {
            <se-fe-empty-state [seFeDataTitle]="'LIST_VIEW.no_results' | translate">
              <se-fe-icon seFeEmptyStateIcon seFeDataName="search_thin" seFeDataSize="950"></se-fe-icon>
              {{ 'LIST_VIEW.change_search_terms' | translate }}
            </se-fe-empty-state>
          } @else if (items.length) {
            @if (activeTab === 'active' && bulkArchiveLimitExceeded) {
              <se-fe-alert class="item-list__bulk-warning" [seFeDataType]="'warning'">
                {{ 'LIST_VIEW.bulk_archive_limit' | translate }}
              </se-fe-alert>
            }
            <se-fe-table-wrapper>
              <table
                seFeTable
                [seFeTableSort]="sortState"
                [dataSource]="items"
                (seFeSortChange)="sortColumns($event)">
                <ng-container seFeColumnDef="select">
                  <th seFeHeaderCell *seFeHeaderCellDef class="item-list__selection-cell">
                  <span
                    [seFeTooltipTrigger]="
                      isSelectAllItemsDisabled() && !bulkArchiving ? selectAllLimitTooltip : null
                    " seFeDataPosition="right">
                    <input
                      type="checkbox"
                      class="item-list__checkbox"
                      data-testid="select-all-sale-items"
                      [attr.aria-label]="'LIST_VIEW.select_all' | translate"
                      [checked]="allVisibleItemsSelected()"
                      [indeterminate]="someVisibleItemsSelected()"
                      [disabled]="isSelectAllItemsDisabled()"
                      (change)="toggleAllVisibleItems($any($event.target).checked)" />
                    <se-fe-tooltip #selectAllLimitTooltip>
                      {{ 'LIST_VIEW.bulk_archive_limit' | translate }}
                    </se-fe-tooltip>
                  </span>
                  </th>
                  <td seFeCell *seFeCellDef="let row" class="item-list__selection-cell">
                  <span
                    [seFeTooltipTrigger]="
                      isItemSelectionDisabled(row.id) && !bulkArchiving ? itemLimitTooltip : null
                    " seFeDataPosition="right">
                    <input
                      type="checkbox"
                      class="item-list__checkbox"
                      [attr.data-testid]="'select-sale-item-' + row.id"
                      [attr.aria-label]="('LIST_VIEW.select_item' | translate: { name: row.name })"
                      [checked]="selectedItemIds.has(row.id)"
                      [disabled]="isItemSelectionDisabled(row.id)"
                      (change)="toggleItemSelection(row.id, $any($event.target).checked)" />
                    <se-fe-tooltip #itemLimitTooltip>
                      {{ 'LIST_VIEW.bulk_archive_limit' | translate }}
                    </se-fe-tooltip>
                  </span>
                  </td>
                </ng-container>

                <ng-container seFeColumnDef="created_at">
                  <th
                    seFeDataRef="created_at"
                    [seFeTableSortHeader]="true"
                    seFeHeaderCell
                    *seFeHeaderCellDef
                    [seFeTestId]="{ label: 'CreatedColumnHeader', isRoot: true }">
                    {{ 'LIST_VIEW.created' | translate }}
                  </th>
                  <td seFeCell *seFeCellDef="let row">{{ row.created_at | date }}</td>
                </ng-container>

                <ng-container seFeColumnDef="name">
                  <th seFeDataRef="name" [seFeTableSortHeader]="true" seFeHeaderCell *seFeHeaderCellDef>
                    {{ 'LIST_VIEW.name' | translate }}
                  </th>
                  <td seFeCell *seFeCellDef="let row">
                    @if (activeTab === 'archived') {
                      <span class="item-list__name">{{ row.name }}</span>
                    } @else {
                      <a class="item-list__name" [routerLink]="[row.id, 'detail']">
                        {{ row.name }}
                      </a>
                    }
                  </td>
                </ng-container>

                <ng-container seFeColumnDef="price_variations_count">
                  <th seFeHeaderCell *seFeHeaderCellDef [seFeTableSortHeader]="true"
                      seFeDataRef="price_variations_count">
                    {{ 'LIST_VIEW.item_variations' | translate }}
                  </th>
                  <td seFeCell *seFeCellDef="let row">{{ row.price_variations_count || '--' }}</td>
                </ng-container>

                <ng-container seFeColumnDef="price">
                  <th seFeHeaderCell class="" *seFeHeaderCellDef>
                    {{ 'LIST_VIEW.price' | translate }}
                  </th>
                  <td seFeCell class="" *seFeCellDef="let row">
                    @if (moreThanOneVariation(row)) {
                      {{ 'LIST_VIEW.prices_may_vary' | translate }}
                    } @else {
                      <span
                        [translate]="'LIST_VIEW.variation_price'"
                        [translateParams]="{ price: row.price || 0.0 | currency }"></span>
                    }
                  </td>
                </ng-container>

                <ng-container seFeColumnDef="sold_count">
                  <th seFeHeaderCell *seFeHeaderCellDef [seFeTableSortHeader]="true" seFeDataRef="sold_count">
                    {{ 'LIST_VIEW.sold' | translate }}
                  </th>
                  <td seFeCell *seFeCellDef="let row">{{ row.sold_count }}</td>
                </ng-container>

                <ng-container seFeColumnDef="sku">
                  <th seFeHeaderCell *seFeHeaderCellDef>
                    {{ 'LIST_VIEW.sku' | translate }}
                  </th>
                  <td seFeCell *seFeCellDef="let row">{{ row.sku || '--' }}</td>
                </ng-container>

                <ng-container seFeColumnDef="archive">
                  <th seFeHeaderCell *seFeHeaderCellDef>
                    <span class="item-list__visually-hidden">{{ 'LIST_VIEW.actions' | translate }}</span>
                  </th>
                  <td seFeCell class="item-list__action-cell" *seFeCellDef="let row">
                    <se-fe-icon-button
                      data-dd-action-name="Archive Sale Item"
                      [seFeTestId]="'archive-sale-item-' + row.id"
                      [seFeDataIsDisabled]="!!archivingItemId"
                      (click)="confirmArchive($event, row)">
                      <se-fe-icon
                        seFeDataName="archive"
                        seFeDataSize="700"
                        [title]="'LIST_VIEW.archive' | translate"
                        [seFeDataAriaLabel]="'LIST_VIEW.archive' | translate"></se-fe-icon>
                    </se-fe-icon-button>
                  </td>
                </ng-container>

                <ng-container seFeColumnDef="archived_actions">
                  <th seFeHeaderCell *seFeHeaderCellDef>
                    <span class="item-list__visually-hidden">{{ 'LIST_VIEW.actions' | translate }}</span>
                  </th>
                  <td seFeCell class="item-list__action-cell" *seFeCellDef="let row">
                    <div class="item-list__actions">
                      <se-fe-icon-button
                        data-dd-action-name="Unarchive Sale Item"
                        [seFeTestId]="'unarchive-sale-item-' + row.id"
                        [seFeDataIsDisabled]="!!archivedItemActionId"
                        (click)="unarchiveItem(row)">
                        <se-fe-icon
                          seFeDataName="unarchive"
                          seFeDataSize="700"
                          [title]="'LIST_VIEW.unarchive' | translate"
                          [seFeDataAriaLabel]="'LIST_VIEW.unarchive' | translate"></se-fe-icon>
                      </se-fe-icon-button>

                      <span
                        [title]="
                        row.can_delete
                          ? ('LIST_VIEW.delete_permanently' | translate)
                          : ('LIST_VIEW.delete_permanently_disabled' | translate)
                      ">
                      <se-fe-icon-button
                        data-dd-action-name="Delete Sale Item Permanently"
                        [seFeTestId]="'delete-sale-item-permanently-' + row.id"
                        [seFeDataIsDisabled]="!row.can_delete || !!archivedItemActionId"
                        (click)="confirmPermanentDelete($event, row)">
                        <se-fe-icon
                          seFeDataName="trash"
                          seFeDataSize="700"
                          [seFeDataAriaLabel]="'LIST_VIEW.delete_permanently' | translate"></se-fe-icon>
                      </se-fe-icon-button>
                    </span>
                    </div>
                  </td>
                </ng-container>

                <tr seFeHeaderRow *seFeHeaderRowDef="displayedColumns; sticky: false"></tr>
                <tr seFeRow *seFeRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </se-fe-table-wrapper>

            <se-fe-pagination
              [seFeDataPaginationOptions]="paginationOptions"
              (seFePaginationChange)="handlePagination($event)"></se-fe-pagination>
          }
        }
      </se-fe-card-content>
    </se-fe-card>
  </se-fe-tab-panel>
</se-fe-page>

<app-registration-warning-modal></app-registration-warning-modal>

@if (showItemModal) {
  <div class="sale-item-element-modal">
    <sale-item-element
      [organizationId]="currentOrgId"
      [showTaxCode]="showTaxCode"
      (closeSaleItemModal)="toggleItemModal()"
      (success)="onSuccess($event.detail)"
      show-sale-item-type="true"></sale-item-element>
  </div>
}
